<template>
  <div id="login" class="row justify-content-center">
    <div class="col align-self-center text-center">
      <div class="mb-4">
        <img
          id="logohome"
          :src="require('../../assets/logocoesia-start.png')"
          class="img-fluid"
        />
      </div>

      <button
        @click="login"
        :class="[{ 'is-loading': loading }, 'btn btn-primary btn-coesia mb-4']"
      >
        <i :class="['fas', loading ? 'fa-spinner' : 'fa-sign-in-alt']"></i>
        Login
      </button>
      
      <div :class="['row justify-content-center mt-4', (!showToggle) ? 'd-none' : '']">
        <div class="col-6 col-xl-2">
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              id="offline"
              value="1"
              @change="switchOffline"
            />
            <label class="form-check-label" for="offline">
              Offline version
            </label>
          </div>
        </div>
      </div>
      
    </div>

    <div class="baffo baffo-sx"></div>
    <div class="baffo baffo-dx"></div>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'LoginBox',
    computed: {
      ...mapGetters(['loading', 'testing', 'offlineMode', 'token', 'appVersion']),
    },
    data() {
      return {
        showToggle: false
      }
    },
    created() {
      this.$store.dispatch('resetLocalStorage')
    },
    mounted() {
      const checkLocalStorage=localStorage.getItem('offline')
      console.log('checkLocalStorage: '+ checkLocalStorage +' testing: '+ this.testing)
      if (checkLocalStorage !== null && !this.testing) {
        this.showToggle = true
        this.$store.dispatch('checkOffline')
        console.log('offlineMode: '+ this.offlineMode)
        if (this.offlineMode) {
          let checkbox = document.getElementById('offline')
          checkbox.checked = true
        }
      } else {
        localStorage.setItem('offline',false)
      }
    },
    methods: {
      login() {
        this.$store.dispatch('login').then(() => {
          if (!this.token) return
          this.$router.push('/events')
        })
        .catch((error) => {
          global.showError(error)
          console.log("POST call unsuccessful :(", error);
        });
      },
      switchOffline() {
        console.log(!this.offlineMode)
        this.$store.dispatch('offline', !this.offlineMode)
      },
    },
  }
</script>

<style>
  #app {
    padding-top: 0;
  }
</style>

<style scoped>
  #login {
    height: 100vh;
    margin: 0;
    position: relative;
  }
  #loading {
    display: none;
  }
</style>
